module.exports = __webpack_public_path__ + "img/tag7.ed9e810c.png";